import { getDataControllerApiUrl } from '../selectors/selectors';

export default {
  fetch(id, action, state) {
    return {
      url: `${getDataControllerApiUrl(state)}/servicing/v1/member`,
      opts: {
        credentials: 'include',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      },
    };
  },
};
